<template>
    <div class="tabbed-box" :class="[rootClasses]">
        <!-- <pre v-if="content" v-text="content"></pre> -->

        <!-- NOTE: Desktop tabbed view -->
        <cmp-tabs v-if="!isMobile"
                :facet="this.content.facet"
                :items="plugins"
                :passive-mode="true"
                :idx="activeTabIdx"
                @request-change="updateState($event, true)">

            <!-- head -->
            <template slot="head" slot-scope="props">
                <span class="tabbed-box--head" v-text="props.item.content.name"></span>
            </template>

            <!-- body -->
            <template slot="body" slot-scope="props">
                <div class="tabbed-box--body">
                    <component :is="props.item.type" :plugin="props.item"></component>
                </div>
            </template>
        </cmp-tabs>

        <!-- NOTE: Mobile accordion view -->
        <cmp-accordion v-if="isMobile"
                v-for="(plugin, pluginIdx) in plugins" :key="pluginIdx"
                :is-active="tabStates[pluginIdx]"
                :passive-mode="true"
                @request-change="updateState(pluginIdx, $event)"
                @changed="onAccordionStateChanged($event)">

            <!-- head -->
            <template slot="head" slot-scope="props">
                <span class="tabbed-box--head"
                        ref="accordionHead"
                        :class="[props.isActive ? 'tabbed-box--head__is-open' : '']">
                    <cmp-scroll-anchor class="tabbed-box--anchor"
                            :id="ariaUid('anchor', pluginIdx)">
                    </cmp-scroll-anchor>
                    <span class="tabbed-box--head-text" v-text="plugin.content.name"></span>
                    <span class="tabbed-box--head-arrow">
                        <cmp-icon v-if="isMobile"
                                class="tabbed-box--head-icon"
                                symbol="chevron_down"
                                size="x-small">
                        </cmp-icon>
                    </span>
                </span>
            </template>

            <!-- body -->
            <template slot="body" slot-scope="props">
                <div class="tabbed-box--body">
                    <component :is="plugin.type" :plugin="plugin"></component>
                </div>
            </template>

        </cmp-accordion>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { toNumeral, numerals } from 'util/dom/mq';
    import ariaMixin from 'vue/mixins/aria';
    import cmsPluginMixin from 'vue/mixins/cms/cms-plugin';
    import bemMixin from 'vue/mixins/bem';


    export default {
        mixins: [
            cmsPluginMixin,
            ariaMixin('tabbed-box'),
            bemMixin('tabbed-box'),
        ],
        data() {
            return {
                tabStates: [],
            };
        },
        computed: {
            ...mapGetters(['viewport']),
            isMobile() {
                return toNumeral(this.viewport.mq.query) < numerals.MD;
            },
            activeTabIdx() {
                let result = this.tabStates.findIndex(val => val);
                return ~result ? result : 0;
            },
            activeAccordionHeadId() {
                return this.ariaUid('anchor', this.activeTabIdx);
            },
            rootClasses() {
                return [
                    this.bemAdd(this.content.facet || 'base'),
                    this.bemAdd(this.isMobile ? 'has-accordion' : 'has-tabs'),
                ];
            },
        },
        methods: {
            updateState(updateIdx, updateVal) {
                if (updateVal) {
                    this.tabStates.forEach((item, idx) => {
                        if (updateIdx === idx) {
                            return;
                        }

                        this.tabStates.splice(idx, 1, false);
                    });
                }

                this.tabStates.splice(updateIdx, 1, updateVal);
            },
            onAccordionStateChanged(newState) {
                if (!newState) {
                    return;
                }

                // NOTE: Anchor method
                //window.location.hash = this.activeAccordionHeadId;

                // NOTE: `scrollIntoView` method
                document.getElementById(this.activeAccordionHeadId).scrollIntoView();
            },
        },
        watch: {
            plugins: {
                handler(plugins) {
                    if (plugins.length <= this.tabStates.length) {
                        return;
                    }

                    plugins.forEach((plugin, idx) => {
                        this.tabStates[idx] = this.tabStates[idx] || false;
                    });
                },
                immediate: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?b57e32c8